export default "__VITE_ASSET__BhVdZgy6__"